import { render, staticRenderFns } from "./LocationSubscriptions.vue?vue&type=template&id=063c2d84&scoped=true"
import script from "./LocationSubscriptions.vue?vue&type=script&lang=js"
export * from "./LocationSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c2d84",
  null
  
)

export default component.exports